import { plugin } from '../constants';

/**
 * Import constants
 */
const {
  SET_UUID,
  SET_PLUGINID,
  SET_PROJECTID,
  SET_STORE_DISTRICTS,
  SET_ENCODE_PLUGINID,
  SET_IS_LOADING,
  SET_X_GW
} = plugin;

/**
 * Action creators
 */
const actions = {
  setUuid: (data) => ({ type: SET_UUID, data }),
  setPluginId: (data) => ({ type: SET_PLUGINID, data }),
  setProjectId: (data) => ({ type: SET_PROJECTID, data }),
  setStoreDistricts: (data) => ({ type: SET_STORE_DISTRICTS, data }),
  setEncodePluginId: (data) => ({ type: SET_ENCODE_PLUGINID, data }),
  setIsLoading: (data) => ({ type: SET_IS_LOADING, data }),
  setXGW: (data) => ({ type: SET_X_GW, data }),
};

export const setUuid = (uuid) => (dispatch) => dispatch(actions.setUuid(uuid));

export const setPluginId = (pluginId) => (dispatch) => dispatch(actions.setPluginId(pluginId));

export const setProjectId = (projectId) => (dispatch) => dispatch(actions.setProjectId(projectId));

export const setIsLoading = (state) => (dispatch) => dispatch(actions.setIsLoading(state));

export const setStoreDistricts = (storeDistricts) => (dispatch) => dispatch(
  actions.setStoreDistricts(storeDistricts)
);

export const setEncodePluginId = (enCodePluginId) => (dispatch) => dispatch(
  actions.setEncodePluginId(enCodePluginId)
);

export const setXGW = (xgw) => (dispatch) => dispatch(actions.setXGW(xgw));
